import { Box, Container, Link, Typography, styled } from "@mui/material"
import type { BoxProps } from "@mui/material/Box"
import { useLocation } from "react-router"

interface TopbarWrapperProps extends BoxProps {
  expand?: boolean
}

const TopbarWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "expand",
})<TopbarWrapperProps>(({ theme, expand }) => ({
  fontSize: 12,
  minHeight: 30,
  color: theme.palette.secondary.contrastText,
  background: theme.palette.error.main,
  transition: "height 300ms ease",
  "& .menuItem": {
    minWidth: 100,
  },
  "& .marginRight": {
    marginRight: "1.25rem",
  },
  "& .expand": {
    display: "none",
    padding: 0,
  },
  "& .handler": {
    height: 40,
  },
  "& .menuTitle": {
    fontSize: 12,
    marginLeft: "0.5rem",
    fontWeight: 600,
  },
  [theme.breakpoints.down("sm")]: {
    height: expand ? 80 : 40,
    "& .topbarRight": {
      display: expand ? "flex" : "none",
      paddingBottom: 5,
    },
    "& .expand": {
      display: "block",
      height: 40,
    },
    "& .MuiSvgIcon-root": {
      color: "white",
    },
  },
}))

const StyledContainer = styled(Container)(({ theme }) => ({
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    alignItems: "start",
    flexDirection: "column",
  },
}))

function Topbar() {
  const location = useLocation()

  return (
    <TopbarWrapper expand={true}>
      <StyledContainer>
        <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
          Omgeving: test-{import.meta.env.VITE_ENVIRONMENT || "development"}
        </Typography>
        <Link
          color="inherit"
          href={`mailto:solutions@satelliet.net?subject=Feedback online Prijslijst&body=Beste Satelliet Solutions,%0D%0A%0D%0AHierbij mijn feedback op de online prijslijst:%0D%0A%0D%0AHuidige pagina: ${window.location.origin}${location.pathname}%0D%0A%0D%0AFeedback:`}
        >
          Feedback
        </Link>
      </StyledContainer>
    </TopbarWrapper>
  )
}

export default Topbar
